import { useEffect, useState } from 'react';
import { getActiveSitesStats } from '../services/bureauManagement/bureauManagement.service';

const LOAD_STATS_ERROR_MESSAGE = 'Failed to load stats';

export interface ActiveSitesStats {
  categoryCounts: Record<string, number>;
  totalAlarms: number;
}

export function useActiveSitesStats() {
  const [stats, setStats] = useState<ActiveSitesStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError(null);
    getActiveSitesStats()
      .then(res => {
        if (mounted && res?.success && res.data) {
          setStats(res.data);
        } else if (mounted) {
          setError(res?.error?.message ?? LOAD_STATS_ERROR_MESSAGE);
        }
        else {
          setError(LOAD_STATS_ERROR_MESSAGE);
          console.info('Stats response received but component is unmounted, skipping state update');
        }
      })
      .catch(e => {
        if (mounted) {
          setError(e?.message ?? LOAD_STATS_ERROR_MESSAGE);
        }
      })
      .finally(() => {
        if (mounted) {
          setLoading(false);
        }
      });
    return () => { mounted = false; };
  }, []);

  return { stats, loading, error };
}
